import React, { useContext, useState } from "react";
import { Form, Input, Button, Checkbox, Typography, Spin } from "antd";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import axios from "axios";
import { toast } from "react-toastify";
import { domainProvider } from "../../contexts/DomainContext";

const { Text, Link } = Typography;

const RegisterForm = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [phone, setPhone] = useState("");
    const [phoneError, setPhoneError] = useState("");
    const { titleName } = useContext(domainProvider);
    console.log(phoneError);

    const selectLanguage = i18next.language;

    const onFinish = async (values) => {
        const fullPhone = `966${phone}`;

        if (fullPhone.length !== 12) {
            setPhoneError(t("form_phone_format") || "Please enter a valid number");
            return;
        }
        setPhoneError("");
        setLoading(true);

        const vendorData = {
            vendor_name: values.user_name,
            store_name: values.storeName.split(" ").join(""),
            vendor_email: values.email,
            vendor_contact: fullPhone,
            password: values.password,
            is_agreed: 1,
        };

        try {
            const res = await axios.post(
                `${process.env.REACT_APP_APIURL}/vendor/register`,
                JSON.stringify(vendorData),
                {
                    headers: { "Content-Type": "application/json" },
                }
            );

            const result = res.data;
            console.log(result);

            if (result.status_code === 200) {
                console.log(result, "result");

                toast.success(result.message);

                navigate("/vendor/verify-email");
            } else {
                toast.error(result.messsage || "Something went wrong.");
            }
        } catch (err) {
            toast.error("Registration failed.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Spin spinning={loading}>
            <Form
                layout="vertical"
                onFinish={onFinish}
                className="w-full max-w-md mx-auto py-5"
            >
                {/* Store Name */}
                <h2 className="text-center text-2xl md:text-3xl mb-4">
                    {t("create_store_title")}
                </h2>
                <Form.Item
                    label={t("create_storeName")}
                    name="storeName"
                    rules={[
                        { required: true, message: t("create_storeName_r") },
                        {
                            pattern: /^(?=.{1,30}$)[a-zA-Z ,.'-]+$/,
                            message: t("store_name_format"),
                        },
                    ]}
                >
                    <Input placeholder={t("create_storeName")} />
                </Form.Item>

                {/* User Name */}
                <Form.Item
                    label={t("create_WName")}
                    name="user_name"
                    rules={[
                        { required: true, message: t("create_WName_r") },
                        {
                            pattern: /^(?=.{1,30}$)[a-zA-Z ,.'-]+$/,
                            message: t("owner_name_format"),
                        },
                    ]}
                >
                    <Input placeholder={t("create_WName")} />
                </Form.Item>

                {/* Email */}
                <Form.Item
                    label={t("l_email")}
                    name="email"
                    rules={[{ required: true, message: t("form_email_req") }]}
                >
                    <Input type="email" placeholder={t("l_email")} />
                </Form.Item>

                <Form.Item
                    label={t("create_mobile")}
                    name="contact"
                    rules={[
                        {
                            required: true,
                            message: t("form_phone_req") || "Please enter your mobile number",
                        },
                        {
                            pattern: /^[0-9]{9}$/,
                            message: t("form_phone_format") || "Mobile number must be 9 digits",
                        },
                    ]}
                >
                    <Input
                        addonBefore="+966"
                        maxLength={9}
                        value={phone}
                        onChange={(e) => {
                            const onlyNums = e.target.value.replace(/[^0-9]/g, "");
                            setPhone(onlyNums);
                        }}
                        onKeyPress={(e) => {
                            if (!/[0-9]/.test(e.key)) {
                                e.preventDefault();
                            }
                        }}
                        placeholder="5XXXXXXXX"
                        size="large"
                    />
                </Form.Item>


                {/* Password */}
                <Form.Item
                    label={t("l_p")}
                    name="password"
                    rules={[
                        {
                            required: true,
                            message: t("l_p_r") || "Password is required",
                        },
                        {
                            pattern: /^(?=.*[0-9])(?=.*[!@#$%^&*]).{6,16}$/,
                            message: t("form_password_format") || "Password must be 6-16 characters long and include at least one number and one special character.",
                        },
                    ]}
                >
                    <Input.Password
                        placeholder={t("")}
                        iconRender={(visible) =>
                            visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                        }
                    />
                </Form.Item>

                {/* Agreement */}
                <Form.Item
                    name="agreement"
                    valuePropName="checked"
                    rules={[
                        {
                            validator: (_, value) =>
                                value
                                    ? Promise.resolve()
                                    : Promise.reject(new Error(t("p_policy") || "You must accept the terms")),
                        },
                    ]}
                >
                    <Checkbox>
                        {t("p_policy")}{" "}
                        <Link onClick={() => window.open("/privacy-policy", "_blank")}>
                            {t("login_p_policy")}
                        </Link>
                    </Checkbox>
                </Form.Item>

                {/* Submit */}
                <Form.Item>
                    <button
                        type="primary"
                        htmlType="submit"
                        disabled={loading}
                        className="w-full btn btn-primary rounded-md text-white mt-4"
                    >
                        {loading ? t("v_loading") : t("regi_btn")}
                    </button>
                </Form.Item>

                <div className="flex flex-col w-full">
                    <div className="divider">{t("have_acc")}</div>
                    <button
                        // type="primary"
                        className="w-full btn btn-primary rounded-md text-white mt-4"
                        // to="/vendor/login"
                        onClick={() => navigate('/vendor/login')}
                    >
                        {t("v_l_f")}
                    </button>
                </div>
            </Form>
        </Spin >
    );
};

export default RegisterForm;
